const jQuery = window.jQuery
import axios from 'axios'

export default {
	methods: {
		setPrivatAreaPoints: function() {
			let url = window.ajax__object.ajax__url

			var formData = new FormData();
			formData.append('action', 'nl_get_current_school_points')
			formData.append('_nounce_value', window.ajax__object._nounce__value)

			axios.post(url, formData)
				.then((response) => {
					jQuery('#school-points').text(response.data.points)
				}, (error) => {
					console.log(error);
				});
		}
	}
}
